import { create } from 'zustand'

interface DiaryCompletedWorksCopyState {
    completedWorkStore?: string | undefined
    loadCompletedWorksStore: (compWrks: string | undefined) => void
}
export const useDiaryCompletedWorksCopyStore = create<DiaryCompletedWorksCopyState>()((set) => ({
    completedWorkStore: undefined,
    loadCompletedWorksStore: (by) => set((state) => ({ completedWorkStore: by })),
}))